import { Form, Formik } from 'formik'

import { DeleteConfirmFormContent } from './delete-confirm-form.component'

import { deleteProfileSchema } from 'src/common/validations'

interface IDeleteConfirmFormProps {
  handleSubmit: () => void | Promise<void>
  disabled?: boolean
}

const DeleteConfirmForm = ({ handleSubmit, disabled }: IDeleteConfirmFormProps) => {
  return (
    <Formik
      initialValues={{ delete: '' }}
      onSubmit={handleSubmit}
      validationSchema={deleteProfileSchema}
      validateOnMount={!disabled}
    >
      <Form>
        <DeleteConfirmFormContent disabled={disabled} />
      </Form>
    </Formik>
  )
}

export { DeleteConfirmForm }
